import { getHotjarSettingsValues } from "@faire/deprecated-retailer-visitor-shared/serialized-data/getHotjarSettingsValues";
import { IUser } from "@faire/web-api--source/indigofair/data/IUser";
import { getGlobalProperty } from "@faire/web/common/globals/getGlobalProperty";
import {
  getPosthogApiKey,
  isPosthogEnabled,
} from "@faire/web/common/posthog/isPosthogEnabled";
import { Posthog } from "@faire/web/common/posthog/posthog";
import { getLocaleKey } from "@faire/web/common/serialized-data/getLocaleKey";
import { uuid } from "@faire/web/common/uuid";

export const initializePosthog = async (
  user: IUser | undefined = IUser.build(),
  isAdminUser: boolean
) => {
  // Use the existing Hotjar recording flag as the master switch for session recording
  // and prefer PostHog if an API key is set.
  if (isAdminUser) {
    return;
  }
  if (!isPosthogEnabled()) {
    return;
  }

  const apiKey = getPosthogApiKey();
  if (!apiKey) {
    return;
  }

  Posthog.initialize(apiKey, {
    apiHost: "https://us.i.posthog.com",
    personProfiles: "identified_only",
  });

  const { token, impersonating, type, retailer_token } = user;
  const language = getLocaleKey()?.language;
  const country = getLocaleKey()?.country;
  const storeType = getGlobalProperty("storeType");

  const identifyToken = token ?? `logged-out-${uuid()}`;

  Posthog.identify(identifyToken, {
    impersonating,
    type,
    retailer_token,
    localeLanguage: language,
    localeCountry: country,
    storeType,
  });

  // Attach experiment/settings values to a dedicated event for filtering replays
  Posthog.capture("session_settings_loaded", getHotjarSettingsValues());
};
